<template>
  <div style="position: relative">
    <!-- filter activity: {{filterActivity}} - testapplypruning: {{testApplyPruning}} - activeTab: {{activeTab}} - {{activeOption}} -->
    <p
      class="font-weight-bold text-right badge-remaining"
      v-if="activeOption == 'Stop' || activeOption == 'Activity'"
      :style="
        totalPaxRemaining == 0
          ? 'background-color:green;'
          : 'background-color:red;'
      "
    >
      PAX restantes: {{ totalPaxRemaining }} / {{ totalPax }}
    </p>
    
    <div v-if="emptyList">
      <p v-if="allBookingsAssigned" class="text-center">
        Todas las reservas están asignadas
      </p>
      <p v-else class="text-center">
        No hay reservas a mostrar
      </p>
    </div>
    <div v-else>
      <div
        class="mt-2"
        v-for="(reserva, index) in testApplyPruning
          ? pruneBookings.filter((r) => r.name != 'Escollera')
          : reservas.filter((r) => r.name != 'Escollera')"
        :key="index"
      >
        <b-card
          v-if="reserva.count_bookings > 0 && (reserva.id == showFilteringActivityGroup || showFilteringActivityGroup == 0 ) "
          no-body
          class="mb-0 card-listing"
        >
          <b-card-header
            header-tag="header"
            class="p-2 card-header-activity"
            role="tab"
          >
            <div class="align-items-baseline d-flex justify-content-center w-100">
              <div class="text-center font-weight-bold">
                {{ reserva.name }}
                

                <span
                  v-if="path !== 'Excursion'"
                  class="ml-2 badge badge-default"
                  >{{ reserva.hora }}</span
                >
              </div>
              <b-button @click="closeBookingInfo(reserva.name)" size="sm" class="border float-right bg-white mt-0 mr-2"  style="position: absolute; right: 0px; top: 0px;">
                <i class="fa fa-eye fa-fw"></i> Plegar / Desplegar
              </b-button>
              
              
            </div>
            <div class="align-items-baseline d-flex justify-content-center w-100 mt-2">
              
              <span class="ml-2 badge badge-default"
                  >Totales: {{ reserva.count_customers }} personas
                  {{ reserva.count_bookings }} reservas</span
                >
                <template v-if="showRemainingBadge">
                  <span
                    class="ml-2 badge"
                    :class="
                      reserva.count_unassigned_customers == 0
                        ? 'badge-success'
                        : 'badge-warning'
                    "
                  >
                    <i
                      v-if="reserva.count_unassigned_customers == 0"
                      class="fa fa-check-circle"
                    ></i>
                    <i v-else class="fa fa-exclamation-triangle"></i>
                    Restantes: {{ reserva.count_unassigned_customers }} personas
                    {{ reserva.count_unassigned_bookings }} reservas
                  </span>
                  <span v-if="activeOption == 'Activity'" class="ml-2 badge badge-default">
                    Actividad:
                    <span>
                      <i :class="reserva.activity != null ? 'fa fa-check-circle text-success' : 'fa fa-exclamation-triangle text-warning'"></i>
                    </span>
                    <span :title="reserva.activity != null && reserva.activity.activity_duration_type ? reserva.activity.activity_duration_type.name : 'Sin determinar'">
                      Duración {{reserva.activity != null && reserva.activity.activity_duration_type ? reserva.activity.activity_duration_type.code : '-'}}
                    </span>
                  </span>
                  
                </template>

                <template v-if="activeOption == 'Pickup' || activeOption == 'Excursion'">
                  <span 
                    v-if="reserva.bus_closed"
                    class="mx-2 badge badge-danger text-white"
                  >
                    <i
                      class="fa fa-lock mx-2"
                      title="Bus cerrado"
                    />
                    Bus cerrado
                  </span>
                </template>
              <b-dropdown
                v-if="activeOption == 'Activity'"
                dropdown
                variant="link"
                toggle-class="text-decoration-none py-0 px-1"
                no-caret
                class="float-right"
                style=""
              >
                <template v-slot:button-content>
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-header class="ml-2">
                  Editar duración
                </b-dropdown-header>
                <b-dropdown-item v-for="duration in activityDurationTypes" :key="duration.id">
                  <div @click="editBulkActivityDurationType(reserva, duration.id)">
                    <i class="fa fa-edit fa-fw"></i> {{duration.name }} 
                  </div>
                  <!-- <show-complete-booking-modal :bookingId="booking.id" /> -->
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-card-header>
          <b-card-body
            class="booking-info"
            :id="reserva.name"
            :style="{ display: isBookingExpanded || itemsExpandedState.filter(item => item.reserva == reserva.name)[0].expanded ? '' : 'none' }"
          >
          <!-- {{itemsExpandedState}} ----------- {{reserva.name}} -->
          <!-- <span style="font-size: 10px;">ttttttt----- {{itemsExpandedState.filter(item => item.reserva == reserva.name)}}</span> -->
            <b-card-text>
              <table class="table table-hover table-sm">
                <thead
                  v-if="reserva.count_unassigned_customers > 0 || !showUnassigned"
                >
                  <tr>
                    <th
                      scope="col"
                      class="text-center"
                      v-if="idBus != '' && (filterActivity == 0)"
                      style="width: 9%"
                    >
                      <span
                        v-if="idBus != ''"
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Asignar todas las reservas"
                      >
                        <b-button
                          class="mr-1"
                          size="sm"
                          variant="success"
                          @click="assignAll(true, reserva.name, idBus)"
                          style="padding: 2px 5px"
                        >
                          <i class="fa fa-check"></i>
                        </b-button>
                      </span>
                      <span
                        v-if="idBus != ''"
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Desasignar todas las reservas"
                      >
                        <b-button
                          class="ml-1"
                          size="sm"
                          variant="danger"
                          @click="assignAll(false, reserva.name, idBus)"
                          style="padding: 2px 5px"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </span>
                    </th>
                    <th
                      scope="col"
                      v-for="(column, index) in columns"
                      :key="index"
                      :style="`width: ${column.width}`"
                    >
                      <span v-if="column.type === 'text'">
                        <template v-if="column.id == 'bus'">
                          {{column.name}} {{busTypeColumnName}}
                        </template>
                        <template v-else>
                          {{ column.name }}
                        </template>
                      </span>
                      <i :class="column.name" v-if="column.type === 'icon'"></i>
                    </th>
                  </tr>
                </thead>
                <!-- <draggable tag="tbody" v-model="reserva.bookings_list" @end="onEndDrag"> -->
                <fragment v-if="activeTab == 'Excursions'">
                  <tbody v-for="(entry, idx) in group(reserva.bookings_list)" :key="idx">
                    <tr>
                      <td colspan="7" class="font-weight-bold">{{idx}}</td>
                    </tr>
                    <booking-card-table-row
                      v-for="(res, idx) in entry"
                      :booking="res"
                      :idBus="idBus == '' ? 0 : idBus"
                      :path="path"
                      :stops="stops"
                      :key="res.id"
                      :bookings="entry"
                      :filterActivity="filterActivity"
                      :idx="idx"
                    />
                  </tbody>
                </fragment>
                <fragment v-else>
                  <tbody>
                    <booking-card-table-row
                      v-for="(res, idx) in reserva.bookings_list"
                      :booking="res"
                      :idBus="idBus == '' ? 0 : idBus"
                      :path="path"
                      :stops="stops"
                      :key="res.id"
                      :bookings="reserva.bookings_list"
                      :filterActivity="filterActivity"
                      :idx="idx"
                    />
                  </tbody>
                </fragment>
                <!-- </draggable> -->
              </table>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import utilsColors from "../../../../utils/colors";
import utils from "../../../../utils/utils";
import stopTimeModal from "../BookingModal/stopTimeModal";
import BookingCardTableRow from "./BookingCardTableRow";
import OperationMixins from "../../../Mixins/OperationMixins.js";
import { mapGetters } from "vuex";
import _ from 'lodash'

import { Fragment } from 'vue-fragment'


export default {
  components: { 
    stopTimeModal, 
    BookingCardTableRow,
    Fragment,
  },
  props: [
    "data",
    "reservas",
    "showUnassigned",
    "isBookingExpanded",
    "showIndividualBookingsUnassigned",
    "showBuses",
    "showFilteringActivityGroup",
    "groupingGroups",
    "filterActivity",
    "idBus",
    "path",
  ],  
  mixins: [OperationMixins, utilsColors, utils],
  data() {
    let itemsExpandedState = []
    
    return {
      columns: [
        { type: "text", name: "Cliente", width: "10%", id: "customer" },
        { type: "text", name: "Num. reserva", width: "4%", id: "nbooking" },
        { type: "text", name: "Hotel", width: "15%", id: "hotel" },
        { type: "text", name: "Hab", width: "2%", id: "room" },
        { type: "text", name: "Actividad", width: "20%", id: "activity" },
        { type: "text", name: "Parada", width: "7%", id: "stop" },
        { type: "text", name: "Idioma", width: "2%", id: "language" },
        { type: "text", name: "Pax", width: "2%", id: "pax" },
        { type: "text", name: "1/2", width: "2%", id: "pax12" },
        { type: "text", name: "Punto venta", width: "10%", id: "agency" },
        { type: "text", name: "Chequeada", width: "6%", id: "check_stop" },
        { type: "text", name: "Duración", width: "5%", id: "duration_type" },
        { type: "text", name: "Bus", width: "8%", id: "bus" },
        { type: "icon", name: "fa fa-wrench", width: "2%", id: "operations" },
      ],
      itemsExpandedState: itemsExpandedState
    };
  },
  mounted() {
    const stopFilter = {
      activity_group: this.$store.getters.filterGroup,
    };
    this.expandedProcessing()

    this.$store.dispatch("stops/loadStops", stopFilter);
    this.pruneBookings;
  },
  methods: {
    expandedProcessing() {
      this.itemsExpandedState = []
      for ( let idx in this.reservas ) {
        let reserva = this.reservas[idx]
        let name = reserva.name
        let state = {
          reserva: reserva.name,
          expanded: true,
        }
        this.itemsExpandedState.push(state)
      }
    },
    async assignAll(shouldAssign, activityName, busId) {
      let requests = []
      for (let i = 0; i < this.reservas.length; i++) {
        const activity = this.reservas[i];
        if (activity.name == activityName) {
          for (let j = 0; j < activity.bookings_list.length; j++) {
            let req = this.assignBus(shouldAssign, activity.bookings_list[j].id, busId, !this.showIndividualBookingsUnassigned, false); //from mixin
            requests.push(req)
          }
        }
      }

      await Promise.all(
        requests
      ).then(() => {
        const bookingData = {
          date: this.$store.getters.filterDate,
          group: this.$store.getters.filterGroup,
          order: "&order_stop=order"
        };
        if ( this.activeTab == 'Excursions') {
          this.$store.dispatch("buses/loadExcursionBuses");
        } else if (this.activeTab == 'Pickups') {
          this.$store.dispatch("buses/loadPickupBuses");
        } else if ( this.activeTab == 'Returns' ) {
          this.$store.dispatch("buses/loadReturnBuses")
        }
      })      
      ///// END LOAD DATA TO REFRESH UI
    },
    
    closeBookingInfo(elementeId) {
      let element = document.getElementById(elementeId);
      element.style.display == "none"
        ? (element.style.display = "")
        : (element.style.display = "none");
      let item = this.itemsExpandedState.findIndex(item => item.reserva == elementeId)
      this.itemsExpandedState[item].expanded = !this.itemsExpandedState[item].expanded
    },
    
    async assignStop(bookingId, stopId) {
      const payload = {
        id: bookingId,
        path: this.path,
        data: {
          stop_schedule: stopId,
        },
      };
      await this.$store.dispatch("bookingsBus/assignStop", payload);
    },
    checkStop(current, original) {
      if (current != undefined && origin != undefined) {
        if (current.toUpperCase() === original.toUpperCase()) return true;
      }
      return false;
    },
    bookingIdsList(reserva) {
      return reserva.bookings_list != null ? reserva.bookings_list.map( (item) => item.id ) : []
    },
    async editBulkActivityDurationType(reserva, duration_id) {
      let list = reserva.bookings_list != null ? reserva.bookings_list.map( (item) => item.id ) : []
      let payload = {
        duration_id: duration_id,
        booking_ids: list
      }
      await this.$store.dispatch("bookings/editBookingActivityDurationType", payload)
      await this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
    },

    group(bookings) {
      let g = _.mapValues(
                _.groupBy(
                    bookings, 'stop.pickup_zone.name'
                ),
            )
      return g
    }
  },
  computed: {
    ...mapGetters(["stops"]),
    ...mapGetters(["activeTab"]),
    ...mapGetters(["activeOption", "activityDurationTypes"]),

    testApplyPruning() {
      const test = this.showUnassigned || this.showIndividualBookingsUnassigned || (this.showBuses && (this.activeOption == 'Excursion' || this.activeOption == 'Pickup') )
      return test
    },
    pruneBookings() {
      console.log('prune requested')
      let pruned = [];
      //console.log("prune bookings begin", this.reservas, this.showBuses);
      if (  (this.activeOption === 'Excursion' || this.activeOption === 'Pickup') && this.showBuses) {
        console.log('prune0')
        this.reservas.forEach((el) => {
          if ( !el.bus_closed ) {
            pruned.push(el)
          }
        })
      } else if ( this.showUnassigned && !this.showIndividualBookingsUnassigned ) {
        console.log('prune 1')
        this.reservas.forEach((el) => {
          if (el.count_unassigned_customers > 0) {
            console.log('count_unassigned_customers', el.count_unassigned_customers)
            let unassignedBookings = [];
            el.bookings_list.forEach((booking) => {
              if (booking.bookingrelbus_set.length == 0) {
                console.log('inside if')
                unassignedBookings.push(booking);
              } else if (booking.bookingrelbus_set.length > 0) {
                console.log('inside elseif')
                let result = booking.bookingrelbus_set.filter( (item) => item.bus_type_rel.type == this.path )
                console.log('booking', booking, this.path)
                console.log('result', result)
                if ( result != null && result.length == 0 ) {
                  unassignedBookings.push(booking)
                }
                // booking.bookingrelbus_set.forEach((element) => {
                //   if (element.bus_type_rel.type !== this.path) {
                //     unassignedBookings.push(booking);
                //     console.log('unassignedBookings ids', unassignedBookings)
                //   }
                // });
              }
            });
            let group = {};
            group = { ...el };
            group.bookings_list = unassignedBookings;
            pruned.push(group);
          }
        });
      } else if ( this.showIndividualBookingsUnassigned ) {
        console.log('prune2')
        this.reservas.forEach((el) => {
          if (el.count_unassigned_customers > 0) {
            let unassignedBookings = [];
            el.bookings_list.forEach((booking) => {
              if (booking.bookingrelbus_set.length == 0) {
                unassignedBookings.push(booking);
              } else if (booking.bookingrelbus_set.length > 0) {
                let hasBusAssignedForCurrentTab = false
                booking.bookingrelbus_set.forEach((element) => {
                  if (element.bus_type_rel.type === this.path) {
                    hasBusAssignedForCurrentTab = true
                  }
                });
                if ( !hasBusAssignedForCurrentTab ) {
                  unassignedBookings.push(booking);
                }
              }              
            });
            let group = {};
            group = { ...el };
            group.bookings_list = unassignedBookings;
            pruned.push(group);
          }
        });
      }
      //console.log("prune bookings finished", pruned)
      //this.expandedProcessing()
      return pruned;
    },
    showRemainingBadge() {
      if (
        (this.activeTab == "Excursions" && this.activeOption == "Activity") ||
        (this.activeTab == "Pickups" && this.activeOption == "Stop") ||
        (this.activeTab == "Returns" && this.activeOption == "Stop")
      ) {
        return true;
      }
      return false;
    },
    totalPaxAssigned() {
      return null;
    },
    totalPaxRemaining() {
      let remaining = 0;
      for (let book in this.reservas) {
        remaining += this.reservas[book].count_unassigned_customers;
      }
      return remaining;
    },
    totalPax() {
      let total = 0;
      for (let book in this.reservas) {
        total += this.reservas[book].count_customers;
      }
      return total;
    },
    busTypeColumnName() {
      if ( this.activeTab == 'Excursions') {
        return " excursión"
      } else if ( this.activeTab == 'Pickups') {
        if ( this.activeOption == 'Excursion' ) {
          return " de recogida"
        } else {
          return " de recogida"
        }
      } else if ( this.activeTab == 'Returns') {
        return " de devolución"
      }
    },
    emptyList() {
      const list = this.showUnassigned
        ? this.pruneBookings.filter((r) => r.name != 'Escollera')
        : this.reservas.filter((r) => r.name != 'Escollera')
      if (list.length == 0 ) {
        return true
      }
      for ( let item in list ) {
        if ( list[item].count_bookings > 0 ) {
          return false
        }
      }
      return true
    },
    allBookingsAssigned() {
      return this.pruneBookings.length == 0 && this.reservas.length > 0
    },
    bookingsExist() {
      return this.reservas.length > 0 && this.showUnassigned
    },
  },
  watch: {
    isBookingExpanded: function() {
      const exp = this.isBookingExpanded
      this.itemsExpandedState = this.itemsExpandedState.map(
        function(item) {
          return {
            reserva: item.reserva,
            expanded: exp
          }
        }
      )
    },
    reservas: function() {
      this.expandedProcessing()
    }
  }
};
</script>

<style scoped>
.badge-remaining {
  padding: 5px 10px;
  margin-right: 10px;
  position: fixed;
  bottom: 0;
  right: 0;
  color: white;
  z-index: 1000;
}
</style>